import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("cp_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const TYPE_LABELS = {
  nda: "NDA Review",
  msa: "MSA / Vendor Contract",
  lease: "Lease Decode",
  invoice: "Invoice Audit",
  resume: "Resume vs Job Description",
  insurance: "Insurance Policy Decode",
  other: "Unrecognized",
};
